import {effect, Inject, Injectable, signal} from '@angular/core';
import {BodyNoScrollEnum} from '../enums/CssClassEnums';
import {DOCUMENT} from '@angular/common';

@Injectable({
  providedIn: 'any',
})
export class NoScrollService {
  public isScrollBlocked = signal<boolean>(false);

  constructor(@Inject(DOCUMENT) private document: Document) {
    effect(() => {
      if (this.isScrollBlocked()) {
        this.document.body.classList.add(BodyNoScrollEnum.NO_SCROLL);
      } else {
        this.document.body.classList.remove(BodyNoScrollEnum.NO_SCROLL);
      }
    });
  }

  public setScrollBlocked(state: boolean): void {
    this.isScrollBlocked.set(state);
  }
}
